import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { propertyAPI } from '../services/api';

const PropertyContext = createContext();

export function PropertyProvider({ children }) {
  const [properties, setProperties] = useState([]);
  const [selectedPropertyId, setSelectedPropertyId] = useState(() => {
    return localStorage.getItem('eden_selected_property') || '';
  });
  const [loading, setLoading] = useState(true);

  const fetchProperties = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await propertyAPI.getAll();
      setProperties(res.data || []);
      const stored = localStorage.getItem('eden_selected_property');
      if (res.data.length > 0) {
        const exists = res.data.some(p => p.id === stored);
        if (!stored || !exists) {
          const firstId = res.data[0].id;
          setSelectedPropertyId(firstId);
          localStorage.setItem('eden_selected_property', firstId);
        }
      }
    } catch {
      setProperties([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => { fetchProperties(); }, [fetchProperties]);

  const selectProperty = (id) => {
    setSelectedPropertyId(id);
    localStorage.setItem('eden_selected_property', id);
    // Dispatch event so other components can react
    window.dispatchEvent(new Event('eden_property_changed'));
  };

  const selectedProperty = properties.find(p => p.id === selectedPropertyId) || null;

  return (
    <PropertyContext.Provider value={{
      properties,
      selectedPropertyId,
      selectedProperty,
      selectProperty,
      loading,
      refreshProperties: fetchProperties
    }}>
      {children}
    </PropertyContext.Provider>
  );
}

export function useProperty() {
  const ctx = useContext(PropertyContext);
  if (!ctx) throw new Error('useProperty must be used within PropertyProvider');
  return ctx;
}
